module.exports = __webpack_public_path__ + "static/media/anchal.87fe79d7.jpg";